import { Card, Input, Button } from '../design-system/components';
import sqViking from '../design-system/assets/sqViking.png';

/**
 * Setup form component for initial configuration
 * Collects API key, Client ID, and Spreadsheet ID
 */
export const SetupForm = ({
  apiKey,
  setApiKey,
  clientId,
  setClientId,
  spreadsheetId,
  setSpreadsheetId,
  webhookUrl,
  setWebhookUrl,
  webhookSecret,
  setWebhookSecret,
  onSubmit
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  const handleClearCredentials = () => {
    if (confirm('Clear saved credentials?')) {
      setApiKey('');
      setClientId('');
      setSpreadsheetId('');
      setWebhookUrl('');
      setWebhookSecret('');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'var(--bg-app)' }}>
      <Card pop className="max-w-md w-full">
        <div className="flex items-center gap-3 mb-6">
          <img src={sqViking} alt="" width={40} height={40} />
          <h1 style={{ fontFamily: 'var(--font-display)', fontWeight: 'var(--fw-semibold)', fontSize: 'var(--text-2xl)', color: 'var(--text-strong)' }}>
            Field Scheduler Setup
          </h1>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            label="Google API Key"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            placeholder="AIza..."
            hint="API Key for Google Sheets access (from Google Cloud Console)"
            required
          />

          <Input
            label="OAuth Client ID"
            value={clientId}
            onChange={(e) => setClientId(e.target.value)}
            placeholder="123456789.apps.googleusercontent.com"
            hint="OAuth 2.0 Client ID for authentication"
            required
          />

          <Input
            label="Spreadsheet ID"
            value={spreadsheetId}
            onChange={(e) => setSpreadsheetId(e.target.value)}
            placeholder="1BxiMVs0XRA5nFMdKvBdBZjgmUUqptlbs74OgvE2upms"
            hint="Spreadsheet ID is the long string in your sheet URL: docs.google.com/spreadsheets/d/{SPREADSHEET_ID}/edit"
            required
          />

          <Input
            label="Apps Script Webhook URL (optional)"
            value={webhookUrl}
            onChange={(e) => setWebhookUrl(e.target.value)}
            placeholder="https://script.google.com/macros/s/.../exec"
            hint="Web App URL from your Apps Script deployment. Triggers email sending immediately after each save."
          />

          <Input
            label="Webhook Secret (optional)"
            value={webhookSecret}
            onChange={(e) => setWebhookSecret(e.target.value)}
            placeholder="Must match WEBHOOK_SECRET script property"
            hint="Must match the WEBHOOK_SECRET script property if your Apps Script deployment enforces one."
          />

          {(apiKey || clientId || spreadsheetId) && (
            <div style={{ background: 'var(--secondary-soft)', border: '2px solid var(--secondary)', borderRadius: 'var(--radius-md)', padding: 'var(--space-3)' }}>
              <div className="flex justify-between items-center">
                <span style={{ fontFamily: 'var(--font-sans)', fontSize: 'var(--text-sm)', color: 'var(--text-strong)' }}>
                  Credentials saved in browser
                </span>
                <button
                  type="button"
                  onClick={handleClearCredentials}
                  style={{ fontFamily: 'var(--font-sans)', fontSize: 'var(--text-xs)', color: 'var(--text-strong)', textDecoration: 'underline', background: 'none', border: 'none', cursor: 'pointer' }}
                >
                  Clear Credentials
                </button>
              </div>
            </div>
          )}

          <Button type="submit" variant="primary" block>
            Continue
          </Button>
        </form>
      </Card>
    </div>
  );
};
